import './teaser-list.scss';

import { sendTracking } from '../../js/tracking';

class TeaserList {
    constructor (element, options) {
        const defaults = {
            resizeTimeout: 150,
            mobileOnlyAttr: 'data-mobileonly',
            trackingAttr: 'data-trackingcategory'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$teaserItems = element;
        this.mobileOnly = false;
        this.trackingCategory = this.$teaserItems.getAttribute(this.settings.trackingAttr);
        this.currentIndex = 0;

        if (this.$teaserItems.getAttribute(this.settings.mobileOnlyAttr) !== null) {
            this.mobileOnly = this.$teaserItems.getAttribute(this.settings.mobileOnlyAttr);
            if (this.mobileOnly === 'true') {
                this.mobileOnly = true;
            }
        }
    }

    initialize () {
        const breakpoint = window.matchMedia('(min-width:1024px)');
        let teaserSlider = null;
        let resizeTimer = null;

        const handleSlider = (Slider) => {
            let clicked = false;
            if (this.mobileOnly === true) {
                if (breakpoint.matches === false) {
                    if (teaserSlider == null) {
                        teaserSlider = new Slider(this.$teaserItems, {
                            breakpoints: null,
                            speed: 500,
                            indicators: true,
                            prevnext: true,
                            slidesPerView: 'auto',
                            initAttr: 'data-teaserlist',
                            onSlideChange: ($slider, slider, $currentSlide, currentIndex) => {
                                if (this.trackingCategory !== null) {
                                    let direction;
                                    if (currentIndex > this.currentIndex) {
                                        direction = 'forth';
                                    } else {
                                        direction = 'back';
                                    }

                                    if (clicked === false) {
                                        sendTracking({
                                            category: this.trackingCategory,
                                            action: 'swipe',
                                            label: 'slide_' + direction + '_' + (currentIndex + 1)
                                        });
                                    }

                                    this.currentIndex = currentIndex;
                                    clicked = false;
                                }
                            },
                            onClickPrev: (currentIndex) => {
                                clicked = true;

                                if (this.trackingCategory !== null) {
                                    sendTracking({
                                        category: this.trackingCategory,
                                        action: 'click',
                                        label: 'btn_back_' + (currentIndex + 1)
                                    });
                                }
                            },
                            onClickNext: (currentIndex) => {
                                clicked = true;

                                if (this.trackingCategory !== null) {
                                    sendTracking({
                                        category: this.trackingCategory,
                                        action: 'click',
                                        label: 'btn_forth_' + (currentIndex + 1)
                                    });
                                }
                            }
                        });
                    }
                } else {
                    if (teaserSlider !== null) {
                        teaserSlider.sliderDestroy();
                        teaserSlider = null;
                    }
                }
            } else {
                if (teaserSlider == null) {
                    teaserSlider = new Slider(this.$teaserItems, {
                        breakpoints: null,
                        speed: 500,
                        indicators: true,
                        prevnext: true,
                        slidesPerView: 'auto',
                        initAttr: 'data-teaserlist',
                        onSlideChange: ($slider, slider, $currentSlide, currentIndex) => {
                            if (this.trackingCategory !== null) {
                                let direction;
                                if (currentIndex > this.currentIndex) {
                                    direction = 'forth';
                                } else {
                                    direction = 'back';
                                }

                                if (clicked === false) {
                                    sendTracking({
                                        category: this.trackingCategory,
                                        action: 'swipe',
                                        label: 'slide_' + direction + '_' + (currentIndex + 1)
                                    });
                                }

                                this.currentIndex = currentIndex;
                                clicked = false;
                            }
                        },
                        onClickPrev: (currentIndex) => {
                            clicked = true;

                            if (this.trackingCategory !== null) {
                                sendTracking({
                                    category: this.trackingCategory,
                                    action: 'click',
                                    label: 'btn_back_' + (currentIndex + 1)
                                });
                            }
                        },
                        onClickNext: (currentIndex) => {
                            clicked = true;

                            if (this.trackingCategory !== null) {
                                sendTracking({
                                    category: this.trackingCategory,
                                    action: 'click',
                                    label: 'btn_forth_' + (currentIndex + 1)
                                });
                            }
                        }
                    });
                }
            }
        };

        import('../../components/slider/slider').then(({ Slider }) => {
            if (this.mobileOnly === true) {
                const handleResize = () => {
                    clearTimeout(resizeTimer);
                    resizeTimer = window.setTimeout(() => {
                        handleSlider(Slider);
                    }, this.settings.resizeTimeout);
                };

                window.addEventListener('resize', handleResize, false);
                window.addEventListener('orientationchange', handleResize, false);
            }

            handleSlider(Slider);
        });
    }
}

export { TeaserList };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$teaserLists = $context.querySelectorAll('[data-teaserlist="slider"]');

        if ($$teaserLists.length > 0) {
            for (let i = 0; i < $$teaserLists.length; i++) {
                const $teaserList = new TeaserList($$teaserLists[i]);
                $teaserList.initialize();
            }
        }
    }
});
